import { Card, styled } from "@mui/material";

export const InterventionCardStyle = styled(Card)({
	".faded": {
		opacity: 0.2,
	},
});
